module.exports = __webpack_public_path__ + "img/40_69_001_810.0d09c9e3.jpg";